/*
  mega-menu.js
  Place in: assets/mega-menu.js
  Load in: snippets/head-scripts.liquid or theme.liquid before </body>
  Add this line before </body> in theme.liquid:
    <script src="{{ 'mega-menu.js' | asset_url }}" defer></script>
*/

(function () {
  const CLOSE_DELAY = 120; // ms before closing after mouse leaves

  let openItem = null;
  let closeTimer = null;

  function openMenu(item) {
    if (openItem && openItem !== item) {
      closeMenu(openItem, true); // instant close previous
    }
    clearTimeout(closeTimer);
    openItem = item;
    item.classList.add('nav-mega--open');

    const trigger = item.querySelector('[data-nav-item-trigger]');
    const panel = item.querySelector('[data-mega-menu]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (panel) panel.setAttribute('aria-hidden', 'false');
  }

  function closeMenu(item, instant) {
    if (!item) return;
    clearTimeout(closeTimer);

    function doClose() {
      item.classList.remove('nav-mega--open');
      const trigger = item.querySelector('[data-nav-item-trigger]');
      const panel = item.querySelector('[data-mega-menu]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.setAttribute('aria-hidden', 'true');
      if (openItem === item) openItem = null;
    }

    if (instant) {
      doClose();
    } else {
      closeTimer = setTimeout(doClose, CLOSE_DELAY);
    }
  }

  function init() {
    const items = document.querySelectorAll('.nav-mega');

    items.forEach(function (item) {
      // Mouse enters nav item
      item.addEventListener('mouseenter', function () {
        openMenu(item);
      });

      // Mouse leaves nav item
      item.addEventListener('mouseleave', function (e) {
        // Check if mouse is going into the mega panel
        const panel = item.querySelector('.mega-menu');
        if (panel && panel.contains(e.relatedTarget)) return;
        closeMenu(item);
      });

      // Mouse enters mega panel — keep open
      const panel = item.querySelector('.mega-menu');
      if (panel) {
        panel.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
        });

        panel.addEventListener('mouseleave', function (e) {
          // Check if going back to nav trigger
          if (item.contains(e.relatedTarget)) return;
          closeMenu(item);
        });
      }

      // Keyboard: Escape closes
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeMenu(item, true);
          const trigger = item.querySelector('[data-nav-item-trigger]');
          if (trigger) trigger.focus();
        }
      });

      // Keyboard: Enter/Space on trigger
      const trigger = item.querySelector('[data-nav-item-trigger]');
      if (trigger) {
        trigger.addEventListener('click', function () {
          if (item.classList.contains('nav-mega--open')) {
            closeMenu(item, true);
          } else {
            openMenu(item);
          }
        });
      }
    });

    // Click outside closes all
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nav-mega')) {
        if (openItem) closeMenu(openItem, true);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();